export const ADD_TOAST_NOTIFICATION = 'ADD_TOAST_NOTIFICATION';
export const CLEAR_NOTIFICATION_CHANNELS = 'CLEAR_NOTIFICATION_CHANNELS';
export const REMOVE_CHIRP_ICON = 'REMOVE_CHIRP_ICON';
export const REMOVE_CHIRP_NOTIFICATION = 'REMOVE_CHIRP_NOTIFICATION';
export const REMOVE_TOAST_NOTIFICATION = 'REMOVE_TOAST_NOTIFICATION';
export const SET_CHIRP_ICON = 'SET_CHIRP_ICON';
export const SET_CHIRP_NOTIFICATION = 'SET_CHIRP_NOTIFICATION';
export const SET_NOTIFICATION_CHANNELS = 'SET_NOTIFICATION_CHANNELS';
